import React from 'react'
import './header.css'
import {Cta} from './Cta'
import Img from '../../assets/about.jpg'
import {About} from '../about/about'
import {HeaderSocial} from './HeaderSocial'

export const Header = () => {

    return (
    <header>
      <section id = "header" className="container header_container">
    
        <h5>Hello I'm</h5>
        <h1>Mehari Tesfaye</h1>
        <h3>Software Engineer</h3>
        <h5>Specialized on full-stack web development</h5>
       
         
          < Cta />
          <HeaderSocial />
          <div ><a href ="#contact"className="scroll_down">scroll down</a></div>
          <div className='about' >
          
          {/* <img  className="me" src = {Img} alt="myphoto" /> */}
          
        </div>
        <About />
      </section>
     
    
    </header>
  )
}
